import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../../components/auth/SignInForm";

export default function SignIn() {
  return (
    <>
      <PageMeta
        title="Sign In | Poultry Book"
        description="Sign in to Poultry Book with your phone number and PIN"
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
